<!--
 * 主页架构组件
 * @author 滕威
 * @time 2021-01-08
 *
-->
<!-- VUE模板(html)代码 start -->
<template>
  <div class="home">
    <el-container>
      <el-header>
        <Header/>
      </el-header>
      <el-container
        style="
          width: 100%;
          display: flex;
        "
      >
        <el-aside :class="[menuState ? 'openMenu' : 'closeMenu']" v-if="flag == '' || flag == null">
          <div class="workbenchMenu-aside" v-if="workbenchMenu === '1'">
            <img class="asideMenu" src="@/assets/images/asideMenu.png">
            <div class="steps">
              <div class="ul">
                <div class="li" v-for="(item,index) in workbenchRouters" :key="index" :class="item.order <= projectScheduleNum ? 'active' : ''">
                  <div class="t">
                    <div class="ro"><i class="el-icon-check" v-if="item.order <= projectScheduleNum" @click="fun_GetMenuPath(item,index + 1)"></i></div>
                    <div class="name" :class="activePath === (index + 1) ? 'nameActive' : ''" :title="item.title" @click="fun_GetMenuPath(item,index + 1)">{{ item.title }}</div>
                  </div>
                  <div class="line"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- 传统菜单 -->
          <Menu v-if="userFlag === '监管人员' && isRouterAlice && workbenchMenu !== '1'" />
          <!-- 悬浮显示子级菜单 -->
          <HoverMenu v-else-if="isRouterAlice && workbenchMenu !== '1'" />
        </el-aside>
        <!-- 工作台进入的页面 -->
         <el-main v-if="workbenchMenu === '1'">
          <div class="img" @click="fun_ShrinkMenu" v-if="flag == '' || flag == null">
            <div class="tit" :class="menuState ? 'closeTit' : 'openTit'">{{ menuState ? "" : "进入导航" }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <!-- 是一览页面 -->
            <router-view
              v-if="$route.path.indexOf('Detail') === -1"
              :key="key"
            />
          <!-- 是详情页面 -->
          <router-view v-if="$route.path.indexOf('Detail') !== -1" :key="key" />
        </el-main>
        <!-- 菜单进入的页面 -->
        <el-main v-else>
          <div class="img" @click="fun_ShrinkMenu" v-if="flag == '' || flag == null">
            <div class="tit" :class="menuState ? 'closeTit' : 'openTit'">{{ menuState ? "" : "进入导航" }}<i :class="menuState ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i></div>
          </div>
          <!-- 为空的工作台 -->
          <Welcome v-if="$route.path === '/home'"/>
          <!-- 是一览页面 -->
            <router-view
              v-if="$route.path.indexOf('Detail') === -1"
              :key="key"
            />
          <!-- 是详情页面 -->
          <router-view v-if="$route.path.indexOf('Detail') !== -1" :key="key" />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<!-- VUE模板(html)代码 end -->

<!-- JS代码 start -->
<script>
import { mapState } from "vuex";
import Menu from "./components/menu";
import HoverMenu from "./components/hoverMenu";
import Header from "./components/header";
import StaffHeader from "./components/staffHeader";
import Breadcrumb from "./components/breadcrumb";
import Welcome from "./components/welcome.vue";
import Workbench from "../page/workbench/index.vue";
import { fun_GetAction } from "@/api";
import { Loading } from "element-ui";
export default {
  name: "Home",
  components: {
    Menu,
    Header,
    StaffHeader,
    HoverMenu,
    Breadcrumb,
    Workbench,
    Welcome,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  // 储存数据
  data: () => {
    return {
      menuState: false,  // 收缩侧边栏图标状态
      flag: null,  // 判断显示菜单
      fullLoading: null,  // 全局加载
      workbenchMenu: null, // 工作台的菜单
      activePath: 1, // 流程状态
      workbenchMenuIndex: 0, // 工作台内容切换
      workbenchRouters: null, // 工作台的菜单路由
      isRouterAlice: true,
      userFlag: null, // 用于判断是否为监管人员
      userType: null, // 用于判断身份
      projectScheduleNum: null, // 工作台流程当前状态
    };
  },
  created() {
    // 获取路由
    this.workbenchRouters = sessionStorage.getItem("workbenchMenu") ? JSON.parse(sessionStorage.getItem("workbenchRouters")) : [];
    // 添加对 sessionStorage 的监听
    window.addEventListener("setItem", () => {
      // 当sessionStorage 中的lang值发生变化， 给组件中的值重新赋值
      this.flag = sessionStorage.getItem("flag") ? sessionStorage.getItem("flag") : null;
      this.workbenchMenu = sessionStorage.getItem("workbenchMenu") ? sessionStorage.getItem("workbenchMenu") : null;
       // 判断是工作台进入
      if(this.workbenchMenu === "1" && this.userFlag === "注册用户"){
        this.menuState = true;
      }
      this.userFlag = sessionStorage.getItem("userFlag") ? sessionStorage.getItem("userFlag") : null;
      this.userType = sessionStorage.getItem("userType") ? sessionStorage.getItem("userType") : null;
      // 获取路由
      this.workbenchRouters = sessionStorage.getItem("workbenchMenu") ? JSON.parse(sessionStorage.getItem("workbenchRouters")) : [];
      // 获取工作台公告流程状态
      this.projectScheduleNum = this.$route.query.projectScheduleNum;
    });
    
  },
  mounted() {
    // 监听浏览器返回
    window.addEventListener('popstate', this.handlePopState);
    // 组件挂载时移除body的overflow
    document.body.style.overflow = "hidden";
  },
  computed: {
    ...mapState(["asyncRouters"]),
    key() {
      return this.$route.path;
    },
  },
  watch: {
    // 监听路由对象中的'$route'属性
    '$route':'getPath'
  },
  // 自定义方法
  methods: {
    /**
     * @description
     */
    reload() {
      this.isRouterAlice = false;
      this.$nextTick(() => {
        this.isRouterAlice = true;
      });
    },
     /**
     * 监听路由传参
     * @param to 当前传递的参数
     * @param from 上一个传递的参数
     */
    getPath(to, from){
      // 判断是首页
      if (to.path === "/home" || to.path === "/msgMessagBoard" || to.path === "/password" || to.path === "/userRegister" || to.path === "/staffWorkbench"){
        // 清空
        this.workbenchMenu = null;
        // 清空存储
        sessionStorage.setItem("workbenchMenu", "");
        sessionStorage.setItem("workbenchRouters", "");
        // 流程初始化
        this.activePath = 1;
        if(to.path === "/home") this.menuState = false;
      }
    },
    /**
     * 浏览器返回方法
     */
     handlePopState() {
      // 判断是首页
      if (this.$route.path === "/home" || this.$route.path === "/msgMessagBoard" || this.$route.path === "/password" || this.$route.path === "/userRegister" || to.path === "/staffWorkbench"){
        // 清空
        this.workbenchMenu = null;
        // 清空存储
        sessionStorage.setItem("workbenchMenu", "");
        sessionStorage.setItem("workbenchRouters", "");
        // 流程初始化
        this.activePath = 1;
      }
    },
    /**
     * 点击跳转
     */
    fun_GetPath(e){
      // 跳转
      this.$router.push({path: e.path, query: { }});
    },
    /**
     * 点击跳转
     */
    fun_GetMenuPath(e,i){
      // 流程
      this.activePath = i;
      // 如果是详情
      if (e.path.indexOf("Detail") !== -1) {
        // 默认跳转第一个
        this.$router.push({path: e.path, query: { id: "", controllerFlg: "detail" }});
      }else{
        // 默认跳转第一个
        this.$router.push({path: e.path, query: { }});
      }
    },
    /**
     * @description 点击图标
     * @author 滕威
     */
    fun_ShrinkMenu() {
      // 切换收缩侧边栏图标状态
      this.menuState = !this.menuState;
      // 判断不是从工作台我的项目进入的菜单
      if(this.workbenchMenu !== "1"){
        // 判断是否打开菜单并且当前在工作台
        if(this.menuState && this.$route.path === "/home" && this.userFlag === '注册用户'){
          // 跳转第一个菜单
          this.$router.push({
            path: this.fun_GetSkipPath(this.asyncRouters),
            // 携带参数主键和状态
            query: {  }
          });
        }
      }
    },
    /**
     * 获取第一个调整路由
     */
    fun_GetSkipPath(array){
      // 声明
      var path;
      // 判断是否存在子级
      if(array[0].children && array[0].children.length > 0){
        path = this.fun_GetSkipPath(array[0].children);
      }else{
        path = array[0].path;
      }
      return path;
    },
  }
};
</script>
<!-- JS代码 end -->

<!-- css样式 start-->
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 7px;
  height: 10px;
  background-color: #fff;
  border-radius: 2px;
}
::-webkit-scrollbar-thumb{
    border-radius: 6px;
    background: rgba(0,0,0,0.2);
}
::-webkit-scrollbar-thumb:hover{
    background: rgba(0,0,0,0.4);
}
.home {
  height: 100%;
  background-color: #F9F9F9;
}
.el-header {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 130px;
  height: 130px !important;
  padding: 0;
  margin-bottom: -40px;
}
.el-header.staffElHeader{
  margin-bottom: 0;
  height: 70px;
  height: 70px !important;
}

.el-container {
  height: 100%;
  overflow: auto;
}

.el-aside {
  background-color: #F1F6F9;
  text-align: center;
  display: block;
  overflow: auto;
  overflow-x: hidden;
  height: 100%;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.05);
  .workbenchMenu-aside {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    min-height: 100%;
    .asideMenu{
      position: absolute;
      bottom: 0;
      left: 0;
      pointer-events: none;
      z-index: 1;
    }
    .steps{
      display: flex;
      box-sizing: border-box;
      overflow: auto;
      .ul{
        display: flex;
        flex-flow: column;
        flex: 1;
        box-sizing: border-box;
        overflow: auto;
        .li{
          // flex-basis: 10%;
          height: 100px;
          z-index: 1;
          position: relative;
          &:last-child{
            .line{
              display: none;
            }
          }
          .t{
            display: flex;
            .ro{
              width: 22px;
              height: 22px;
              border-radius: 50px;
              background: #FFFFFF;
              border: 1px solid #BFBFBF;
              margin-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              i{
                color: #BFBFBF;
              }
            }
            .name{
              font-weight: bold;
              font-size: 18px;
              color: #303946;
              white-space: nowrap; 
              overflow: hidden; 
              text-overflow: ellipsis; 
              cursor: pointer;
              flex: 1;
              text-align: left;
            }
            .name.nameActive{
              color: #0E70B5;
            }
          }
          .line{
            width: 2px;
            height: 100%;
            background: #D0D7E2;
            position: absolute;
            left: 11px;
            top: 0;
            z-index: -1;
          }
        }
        .li.active{
          .t{
            .ro{
              background: #0E70B5;
              border-color: #0E70B5;
              i{
                color: #FFFFFF;
              }
            }
          }
          .line{
            background: #0E70B5;
          }
        }
      }
    }
    /deep/.el-steps{
      .el-step{
        flex-basis: 0 !important;
        .el-step__main{
          .el-step__title{
            margin-top: -3px;
            .title{
              cursor: pointer;
              cursor: pointer;
              font-weight: bold;
              font-size: 18px;
              color: #303946;
            }
          }
        }
        .el-step__head{
          padding-bottom: 50px;
          margin-top: -1px;
          .el-step__line{
            background: #D0D7E2;
          }
          .el-step__icon{
            width: 22px;
            height: 22px;
            border-radius: 50px;
          }
          .el-step__icon-inner{
            background: #FFFFFF;
            border-color: #BFBFBF;
            color: #BFBFBF;
            font-size: 16px;
          }
        }
        .el-step__head.is-success{
            border-color: #0E70B5;
            .el-step__icon{
              background: #0E70B5;
              border-color: #0E70B5;
              color: #FFFFFF;
              .el-step__icon-inner{
                background: #0E70B5;
                color: #FFFFFF;
              }
            }
          }
        .is-process,.is-wait{
          .el-step__line{
            background: #D0D7E2;
          }
          .el-step__icon{
            background: #FFFFFF;
            border-color: #BFBFBF;
          }
        }
      }
      .active{
        .el-step__main{
          .el-step__title{
            .title{
              color: #0E70B5;
            }
          }
        }
      }
    }
  }
}
// .el-aside:hover {
//   .img {
//     display: block !important;
//   }
// }

.openMenu {
  // width: 220px !important;
  width: 200px !important;
  transition: 0.3s;
}
@media (min-width: 2160px) {
  .openMenu {
    width: 230px !important;
  }
}
.closeMenu {
  width: 0 !important;
  transition: 0.3s;
}

.el-main {
  //background-color: #F6F9FF;
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  .img {
    z-index: 4;
    position: absolute;
    top: 40%;
    left: 0;
    cursor: pointer;
    // display: none;
    .tit{
      writing-mode: vertical-rl;
      background: #0E70B5;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      color: #FFFFFF;
      font-size: 18px;
      font-weight: bold;
    }
    .tit.closeTit{
      padding: 7px 2px;
      i{
        margin-top: 0;
        font-size: 18px;
      }
    }
    .tit.openTit{
      padding: 10px 8px;
      i{
        margin-top: 5px;
        font-size: 18px;
      }
    }
  }
}
</style>
<!-- css样式 end-->
